module.exports = __webpack_public_path__ + "static/media/medaille3.cf19b0c2.png";